import React, {Component} from "react";
import {ButtonToolbar, Col, ControlLabel, Form, FormControl, FormGroup} from "react-bootstrap";
import {TopSelect} from "../../../../../componentsTopsa/selects/TopSelects";
import initialData from "../../../../../utilities/initialData/initialData";
import acc from "accounting";
import ValidatorMessages from "../../../../../shared/validatorMessages/ValidatorMessages";
import {TopButtonCancel, TopButtonSave} from "../../../../../componentsTopsa/buttons/TopButtons";
import KartyService from "../../../../klienciConfig/karty/KartyService";
import KlienciService from "../../../../klienciConfig/KlienciService";
import KartaDanegoKlienta from "../../../../klienciConfig/klienci/externalComponents/KartaDanegoKlienta";
import ZnizkiService from "../../znizki/ZnizkiService";

export default class EdycjaMiesiecznegoForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            validatorMessages: [],
            cena: 0,
            rok: '',
            miesiac: null,
            uwagi: '',
            statusy: [{value: -1, label: 'do opłaty'}, {value: 1, label: 'opłacony'}],
            status: null,
            karta: null,
            klient: null,
        };
        this.onChangeRok = this.onChangeRok.bind(this)
        this.onChangeMiesiac = this.onChangeMiesiac.bind(this)
        this.onChangeUwagi = this.onChangeUwagi.bind(this)
        this.onClickZapisz = this.onClickZapisz.bind(this)
    }

    componentDidMount() {
        this.ustawWartosci(this.props)
    }

    componentWillReceiveProps(nextprops) {
        this.ustawWartosci(nextprops)
    }

    ustawWartosci(props) {
        if (Boolean(props.bilet)) {
            this.setState({
                cena: parseInt(props.bilet.cena),
                rok: props.bilet.rok,
                miesiac: initialData.returnArrayMiesiace().find(m => m.value == props.bilet.miesiac),
                uwagi: props.bilet.uwagi,
                status: this.state.statusy.find(s=>s.value==props.bilet.status),
            })
            KartyService.getKarta(props.bilet.idKa).then(function (response) {
                if (Boolean(response.data)) {
                    this.setState({karta: response.data})
                    if (Boolean(response.data)) {
                        KlienciService.getKlient(response.data.idKl).then(function (response) {
                            this.setState({klient: response.data})
                        }.bind(this))
                    }
                }
                else {
                    alert('Nie udało się pobrać karty')
                }
            }.bind(this)).catch(err => {
                alert('Nie udało się pobrać karty, '+err)
            })
            document.getElementById('inputRok').value = props.bilet.rok;
            document.getElementById('inputUwagi').value = props.bilet.uwagi
        }
    }

    onChangeRok(e) {
        this.setState({
            rok: e.target.value
        })
        if (e.target.value >= new Date().toJSON().substr(0, 4) && e.target.value < 3000) {
            if (Boolean(this.state.miesiac) && Boolean(this.state.karta)) {

                let msc = this.state.miesiac.value
                if (this.state.miesiac.value.length === 1) {
                    msc = '0' + (this.state.miesiac.value).toString()
                }
                let okr = '01'
                if (this.state.karta.okres == 'P2') okr = '16'

                let data = e.target.value + '-' + msc + '-' + okr
                this.pobierzCenyBiletowMiesiecznych(this.state.karta, data)
            }
        }
    }

    onChangeMiesiac(e) {
        this.setState({miesiac: e})
        if (e !== null) {
            if (Boolean(this.state.karta) && (this.state.rok).toString().length === 4) {
                let msc = e.value
                if (e.value.length === 1) {
                    msc = '0' + (e.value).toString()
                }
                let okr = '01'
                if (this.state.karta.okres == 'P2') okr = '16'

                let data = this.state.rok + '-' + msc + '-' + okr
                this.pobierzCenyBiletowMiesiecznych(this.state.karta, data)
            }
        }
    }

    onChangeUwagi(e) {
        if (e.target.value.length <= 200) {
            this.setState({uwagi: e.target.value})
        } else {
            document.getElementById('inputUwagi').value = this.state.uwagi
        }

    }

    dodajDoValidatorMessages(mess) {
        let arr = this.state.validatorMessages
        arr.push(mess)
        this.setState({validatorMessages: arr})
    }

    onClickZapisz() {

        this.setState({validatorMessages: []})
        this.state.validatorMessages = []
        let poprawne = true;

        if (this.state.rok < new Date().toJSON().substr(0, 4) || this.state.rok > 3000) {
            this.dodajDoValidatorMessages('Nie podano prawidłowego roku')
            poprawne = false
        }
        if (!Boolean(this.state.miesiac)) {
            this.dodajDoValidatorMessages('Nie wybrano miesiąca')
            poprawne = false
        }
        if (!Boolean(this.state.status)) {
            this.dodajDoValidatorMessages('Nie wybrano statusu')
            poprawne = false
        }
        if (!Boolean(this.state.cena)) {
            this.dodajDoValidatorMessages('Cena jest zerowa - należy sprawdzić datę ważności cennika')
            poprawne = false
        }

        if (poprawne) {
            let data = {
                "cena": this.state.cena,
                "miesiac": this.state.miesiac.value,
                "rok": this.state.rok,
                "statBil": this.state.status.value,
                "uwagi": this.state.uwagi,
                "idKa":this.state.karta
            }
            this.props.handleClickZapisz(data)
        }

    }

    pobierzCenyBiletowMiesiecznych(karta, data) {

        let obj = {
            "data": data,
            "idMiDo": karta.idMiDo,
            "idMiOd": karta.idMiOd,
            "idTr": karta.idTr,
            "kierunek": karta.kierunek,
            "okres": karta.okres
        }

        ZnizkiService.getWszytskieZnizkiMiesieczne(obj).then(function (response) {
            if (response.data.length > 0) {
                this.setState({cena: response.data.find(z => z.rodz === karta.rodz).cena})
            }
        }.bind(this))
    }

    render() {
        return (
            <div style={{marginTop: '15px'}}>
                <fieldset>
                    <div className={'fieldset-label'}>Edycja biletu miesięcznego</div>
                    <Form horizontal={true}>
                        <FormGroup>
                            <Col xs={1}>
                                <ControlLabel>
                                    Rok <span className={'req'}>*</span>
                                </ControlLabel>
                                <FormControl defaultValue={new Date().toJSON().substr(0, 4)} type={'number'}
                                             onChange={this.onChangeRok} id={'inputRok'}/>
                            </Col>
                            <Col xs={1}>
                                <ControlLabel>
                                    Miesiąc <span className={'req'}>*</span>
                                </ControlLabel>
                                <TopSelect onChange={this.onChangeMiesiac} value={this.state.miesiac}
                                           options={initialData.returnArrayMiesiace()} clearable={false}/>
                            </Col>
                            <Col xs={1}>
                                <ControlLabel>
                                    Cena
                                </ControlLabel>
                                <FormControl disabled={true} value={acc.formatMoney(this.state.cena)}/>
                            </Col>
                            <Col xs={2}>
                                <ControlLabel>
                                    Status <span className={'req'}>*</span>
                                </ControlLabel>
                                <TopSelect onChange={(e) => {
                                    this.setState({status: e})
                                }}
                                           value={this.state.status}
                                           options={this.state.statusy}
                                           clearable={false}
                                />
                            </Col>
                            <Col xs={4}>
                                <ControlLabel>
                                    Uwagi
                                </ControlLabel>
                                <FormControl onChange={this.onChangeUwagi} id={'inputUwagi'}/>
                            </Col>
                            <Col xs={3}>
                                <div className={'add-label-margin'}></div>
                                <ButtonToolbar>
                                    <TopButtonCancel onClick={() => this.props.handleClickAnuluj()}/>
                                    <TopButtonSave onClick={this.onClickZapisz}/>
                                </ButtonToolbar>
                            </Col>
                        </FormGroup>
                        {
                            Boolean(this.state.karta) ?
                                <FormGroup>
                                    <Col xs={12} lg={5}>
                                        <KartaDanegoKlienta klient={this.state.klient} karta={this.state.karta}/>
                                    </Col>
                                </FormGroup>
                                :
                                ''
                        }
                        <FormGroup>
                            <ValidatorMessages messages={this.state.validatorMessages}/>
                        </FormGroup>
                    </Form>
                </fieldset>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/konfiguracja/biletyConfig/biletyMiesieczne/components/EdycjaMiesiecznegoForm.js